const withTaxList = [
  { value: null, name: '　' },
  { value: false, name: '未稅電費' },
  { value: true, name: '含稅電費' }
];
export default withTaxList;
